import Button from "../../component/Button/Button";
import React from "react";
import useSwitchNetwork from "./Utils";
import { motion } from "framer-motion";
// import Button from "../../component/Button/Button";

const TopBar = (props) => {
  // console.log("props",props.text)
  const { networkSwith } = useSwitchNetwork();
  return (
    <>
      <div className={`section-topbar ${props.animationCls}`}>
        <div className="container-1280">
          <div className="row hz-message-top">
            {/* <div className="col-lg-2">
              <nav className="navbar navbar-light ">
                <a className="navbar-brand">
                  <img
                    src={props.image}
                    className="d-inline-block align-top"
                    alt=""
                  />
                </a>
              </nav>
            </div> */}
            <div className="col-lg-10 d-block">
              <div className="hz-message-content">
                <p>
                  <span>{props.text.type}:</span> {props.text.message}
                </p>
                <div className=" top-bar">
                
                <img
                  className="cross-img"
                  src={require("../../Assets/img/cross.png")}
                  onClick={() => props.click()}
                  alt="cross"
                />

                {props.text.code === 400 ? (
                  <div className="button">
                    <Button
                      onClick={() => {
                        networkSwith();
                      }}
                      value="Switch to Polygon"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              
            </div>

              {/* <p
                className="switch-btn"
                onClick={() => {
                  networkSwith();
                }}
              >
                Switch to Polygon
              </p> */}
            </div>

            
            
          <div>
            <img className="hz-hourglass" src={require('../../Assets/img/hourglass.png')}/>
          </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TopBar;
